import React from 'react'
import {authRoles} from '../../auth/authRoles'

const UserRoutes = [
        {
                path: '/user/myprofile/',
                component: React.lazy(() => import('./MyProfile')),
                auth: authRoles.myProfile,
        },
        // {
        //         path: '/user/add',
        //         component: React.lazy(() => import('./RegisterUser')),
        //         auth: authRoles.registerUser,
        // },
        {
                path: '/user/review/:id',
                component: React.lazy(() => import('./ReviewUser')),
                auth: authRoles.userManagement,
        },
        {
                path: '/users',
                component: React.lazy(() => import('./UserManagement/UserManagement')),
                auth: authRoles.userManagement,
        },
        {
                path: '/orgadmin/users',
                component: React.lazy(() => import('./UserManagement/UserManagementWithoutTabs')),
                auth: authRoles.orgAdminUserManagement,
        },
        // {
        //         path: '/users/individual',
        //         component: React.lazy(() => import('./UserManagement/IndividualUsers')),
        //         auth: authRoles.userManagement,
        // },
        // {
        //         path: '/users/organizational',
        //         component: React.lazy(() => import('./UserManagement/OrganizationUsers')),
        //         auth: authRoles.userManagement,
        // },
]

export default UserRoutes